import { leftSidebarIdAtom, rightSidebarIdAtom, shouldSaveRightSidebarPreferenceAtom, } from 'js/file_viewer/core/atoms/plugins';
import { areLineNumbersHiddenAtom } from 'js/file_viewer/core/atoms/ui/text';
import { mutedAtom, volumeAtom } from 'js/file_viewer/core/atoms/volume';
export const makePreferenceClientEffects = (store, preferencesClient) => {
    const unsubVolume = store.sub(volumeAtom, () => {
        var _a;
        const volume = store.get(volumeAtom);
        (_a = preferencesClient.video) === null || _a === void 0 ? void 0 : _a.setVolumeState(volume);
    });
    const unsubMuted = store.sub(mutedAtom, () => {
        var _a;
        const muted = store.get(mutedAtom);
        (_a = preferencesClient.video) === null || _a === void 0 ? void 0 : _a.setMuteState(muted);
    });
    const unsubLineNumbersHidden = store.sub(areLineNumbersHiddenAtom, () => {
        var _a;
        const areHidden = store.get(areLineNumbersHiddenAtom);
        (_a = preferencesClient.ui) === null || _a === void 0 ? void 0 : _a.setLineNumbersAreHidden(areHidden);
    });
    const unsubLeftSidebarPlugin = store.sub(leftSidebarIdAtom, () => {
        var _a;
        const leftSidebarId = store.get(leftSidebarIdAtom);
        (_a = preferencesClient.sidebar) === null || _a === void 0 ? void 0 : _a.setLeftSidebarState(leftSidebarId);
    });
    const unsubRightSidebarPlugin = store.sub(rightSidebarIdAtom, () => {
        var _a;
        const rightSidebarId = store.get(rightSidebarIdAtom);
        const shouldSave = store.get(shouldSaveRightSidebarPreferenceAtom);
        if (shouldSave) {
            (_a = preferencesClient.sidebar) === null || _a === void 0 ? void 0 : _a.setRightSidebarState(rightSidebarId);
        }
    });
    return () => {
        unsubVolume();
        unsubMuted();
        unsubLineNumbersHidden();
        unsubLeftSidebarPlugin();
        unsubRightSidebarPlugin();
    };
};
//# sourceMappingURL=preferences.preenvesnextjs.map
